if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', class FreeShippingBar extends HTMLElement {
    constructor() {
      super();
      this.messages = {};
      ['unreached', 'mid', 'reached'].forEach((name) => {
        const element = this.querySelector(`.free-shipping-bar__${name}-message`);
        if (element) {
          this.messages[name] = { element: element, template: element.innerHTML };
        }
      });
      this.percentNumber = this.querySelector('.free-shipping-bar__progress-number');
      if (this.dataset.showExcludeMessage) {
        this.excludeMessage = this.querySelector('.free-shipping-bar__exclude-message');
        this.excludeMessageText = this.excludeMessage.innerHTML;
      }
      if(!this.dataset.threshold) return;
      this.threshold = parseInt(this.dataset.threshold);
      this.midThreshold = parseInt(this.dataset.midThreshold) || 0;
      this.update(this.dataset);
      this.onCartChangeHandler = this.onCartChange.bind(this);
      document.addEventListener('afterCartChanged', this.onCartChangeHandler);
      document.addEventListener('afterUpdateQuantity', this.onCartChangeHandler);
      if (this.dataset.forceBike === 'true') {
        this.onVariantChangeHandler = this.onVariantChange.bind(this);
        document.addEventListener('afterVariantChanged', this.onVariantChangeHandler);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('afterCartChanged', this.onCartChangeHandler);
      document.removeEventListener('afterUpdateQuantity', this.onCartChangeHandler);
      if (this.onVariantChangeHandler) document.removeEventListener('afterVariantChanged', this.onVariantChangeHandler);
    }

    /**
     * The bar is only relevant once a bike is in the cart, so `hasBike` (computed in
     * Liquid, see snippets/free-shipping-bar-state.liquid) drives its visibility.
     * Exception : sur la fiche d'un vélo (`data-force-bike="true"`), la barre reste
     * toujours visible, même panier vide.
     */
    update(state) {
      const hasBike = this.dataset.forceBike === 'true' || state.hasBike === 'true';
      this.dataset.hasBike = hasBike ? 'true' : 'false';
      if (!hasBike) return;
      this.lastState = { total: state.total, countExcludeProducts: state.countExcludeProducts, productInCart: state.productInCart };
      this.countExcludeProducts = parseInt(state.countExcludeProducts) || 0;
      let total = parseInt(state.total) || 0;
      // Fiche vélo : on compte le vélo consulté comme s'il était ajouté au panier (sauf s'il y est déjà).
      if (this.dataset.forceBike === 'true' && state.productInCart !== 'true') {
        total += parseInt(this.dataset.productPrice) || 0;
      }
      this.calculateBar(total);
      this.toggleExcludeMessage();
    }

    calculateBar(currentTotal) {
      const total = currentTotal / parseFloat(Shopify.currency.rate);
      const percent = Math.min((total * 100) / this.threshold, 100);
      this.style.setProperty('--percent', `${percent}%`);
      this.classList.toggle('completed', total >= this.threshold);
      this.percentNumber.textContent = `${Math.floor(percent)}%`;

      if (total >= this.threshold) {
        this.showMessage('reached');
      } else if (this.midThreshold && total >= this.midThreshold) {
        this.showMessage('mid', this.threshold - total);
      } else {
        this.showMessage('unreached', this.threshold - total);
      }
    }

    showMessage(name, remainAmount) {
      Object.keys(this.messages).forEach((key) => {
        this.messages[key].element.classList.toggle('hidden', key !== name);
      });
      const message = this.messages[name];
      if (!message) return;
      message.element.innerHTML = message.template.replace('[remain]', this.constructor.formatPrice(remainAmount));
    }

    /**
     * Formatted from the active currency rather than `shop.money_format`, which still
     * carries a `$` sign on this shop.
     */
    static formatPrice(amount) {
      if (typeof amount === 'undefined') return '';
      const converted = (amount * parseFloat(Shopify.currency.rate)) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
          style: 'currency',
          currency: Shopify.currency.active,
        }).format(converted);
      } catch (e) {
        return Shopify.showPrice(amount);
      }
    }

    toggleExcludeMessage() {
      if (!this.dataset.showExcludeMessage) {
          return
      }
      if (!this.countExcludeProducts) {
          this.excludeMessage.classList.add('hidden')
      } else {
          this.excludeMessage.innerHTML = this.excludeMessageText.replace('[product_count]', this.countExcludeProducts);
          this.excludeMessage.classList.remove('hidden')
      }
    }

    onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (!variant || typeof variant.price === 'undefined') return;
      this.dataset.productPrice = variant.price;
      if (this.lastState) this.update(this.lastState);
    }

    onCartChange() {
      fetch(`${window.location.pathname}?sections=free-shipping-bar`)
      .then((response) => response.json())
      .then((sections) => {
        const rendered = new DOMParser().parseFromString(sections['free-shipping-bar'], 'text/html');
        const state = rendered.getElementById('free-shipping-bar-state');
        if (!state) return;
        this.update(state.dataset);
      });
    }
  });
}
